import React, { useState } from 'react';
import SanitizedMarkdown from 'design-system/SanitizedMarkdown';
import { Label, Button, InputText } from 'design-system/Form';
import apiFetch, { defaultApiFetchErrorHandler } from 'react-scale/lib/api-fetch';
// import SelectCustomer from 'corp/components/UI/SelectCustomer';
import SelectCustomerV2 from 'corp/components/UI/SelectCustomerV2';
import { FindUserJSON } from '@scale/shared/types/api/corp-api/find';

const description = `
### Description:
- This tool allows you to mark a Bee TTS batch as incomplete.
- Select the project and batch, and then click the button to mark the batch as incomplete.

##### Author: Carlos Gonzalez
---
`;

// const APPLE_CUSTOMER_ID = '619453fb628b9200344887e2';

const IncompleteBatch = () => {
  const [batches, setBatches] = useState<string[] | null>();
  const [message, setMessage] = useState<string>();
  const [customer, setCustomer] = useState<FindUserJSON | null>(null);

  const handleCustomer = (value: FindUserJSON | null) => {
    setCustomer(value);
  };

  const renderOutput = () => {
    return (
      <div className="response-markdown">
        <SanitizedMarkdown text={message || ''} />
        <style jsx global>{`
          .response-markdown tr {
            border: 1px solid rgba(0, 0, 0, 0.3);
          }

          .response-markdown tr:nth-child(even) {
            background-color: #f2f2f2;
          }

          .response-markdown th {
            border: 1px solid rgb(0, 0, 0, 0.3);
            padding: 6px 10px;
            background-color: #f2f2f2;
          }

          .response-markdown th {
            border: 1px solid rgba(255, 255, 255, 0.3);
            padding: 6px 10px;
            background-color: #222;
            color: white;
          }

          .response-markdown td {
            border: 1px solid rgba(0, 0, 0, 0.3);
            padding: 10px;
          }
        `}</style>
      </div>
    );
  };

  const handleIncomplete = async () => {
    // eslint-disable-next-line no-console
    console.log(`Marking batches ${batches} as incomplete`);

    try {
      const res = await apiFetch(null, 'corp-api/bee-tts-utils/metadata', {
        method: 'PUT',
        body: {
          batchNames: batches,
          customerId: customer,
          metadata: {
            isReturned: false,
          },
        },
      });
      setCustomer(null);
      setBatches([]);
      setMessage(res.message);
    } catch (error) {
      defaultApiFetchErrorHandler(error, { handleHttp: true });
    }
  };

  const onChangeBatches = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newBatches = event.target.value.split(',').map(batch => batch.trim());
    setBatches(newBatches);
  };

  const selectBatch = () => {
    return (
      <div className="inputComponent">
        <InputText
          placeholder="Batches Names (comma separated)"
          value={batches?.join(',')}
          onChange={onChangeBatches}
        />
      </div>
    );
    // <Select value={batch} onChange={handleBatch} options={batchOptions} />;
  };

  const buttonText = () => {
    if (!customer) return 'Select customer';
    if (!batches) return 'Select batches';
    return 'Mark batches as incomplete';
  };

  return (
    <div className="root">
      <section>
        <SanitizedMarkdown text={description} />
      </section>

      <section className="two-columns">
        <section>
          <Label>Batches:</Label>
          {selectBatch()}
        </section>
        <section>
          <Label>Customer:</Label>
          <SelectCustomerV2 value={customer} onChange={handleCustomer} />
        </section>
      </section>
      <br />
      <section>
        <Button
          primary
          disabled={!batches || !batches.length}
          requireConfirmation
          onClick={handleIncomplete}
        >
          {buttonText()}
        </Button>
        {message && renderOutput()}
      </section>
      <style jsx>{`
        .root .two-columns {
          display: flex;
        }
        .root .two-columns section {
          flex-basis: 50%;
        }
        .root .two-columns section.disabled {
          color: rgba(0, 0, 0, 0.3);
        }
        .root .inputComponent {
          margin-top: 12px;
        }
      `}</style>
    </div>
  );
};

export default IncompleteBatch;
